export const environment = {
  production: true,
  showReports: true,

  // Authentication API URL
  authRoot: 'https://loginbeta.snapon.com',

  // Landing page root
  webRoot: 'https://impactbeta.snapon.com',

  // SignalR URL
  signalR: '/progressHub',

  // Session Timeout (in seconds)
  sessionTimeoutSeconds: 3600,

  // Session Timeout idle check (in seconds)
  idleCheckIntervalSeconds: 30,

  // Payment Chase URL HPS2
  paymentChaseUrl: 'https://www.chasepaymentechhostedpay-var.com/hpf/1_1',

  // Payment Chase URL HPS3
  paymentChaseUrlHPS3: 'https://chase-var.hostedpaymentservice.net/hpf/',

  // HPF Post Messaging Chase URL HPS3
  hpfPMChaseUrlHPS3: 'https://chase-var.hostedpaymentservice.net/includes/hpfParent.min.js?enable_spa_support=1',

  // Offline API
  offlineApiRoot: 'http://localhost:5000',

  // B2B API URL
  b2bApiRoot: 'https://b2bbeta.snapon.com',

  // GTM ID
  gtmId: 'GTM-NBN43N8Q',

  // Clarity ID
  clarityId: 'nycnv99en8',

  // Formbricks
  formbricksEnabled: false,
  formbricksAppUrl: 'https://app.formbricks.com',
  formbricksWorkspaceId: 'cmpqyxkhg6e9rwq01odm5bg42',

  // style versioning to prevent imperva caching
  // Power BI report page names
  powerBiPageNames: {
    accountManager: '65adaf530902d5e098ee',
    admin: '7eeee769e4c3c604067b'
  },

  styleVersion: 13
};
